export const quest_page = {
	QUEST_DAILY_HEADER: {
		value: 'WEEKLY QUESTS',
		config: {
			fontName: 'custom_font',
			fontSize: 40,
			letterSpacing: 5
		}
	},
	QUEST_DAILY_TITLE: {
		value: 'Complete All Weekly Quests',
		config: {
			fill: '#F09833',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	QUEST_DAILY_TITLE_MOBILE_0: {
		value: 'Complete All Weekly Quests',
		config: {
			fill: '#B7EE71',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	QUEST_DAILY_TITLE_MOBILE_1: {
		value: 'Weekly Quests',
		config: {
			fill: '#B7EE71',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	QUEST_DAILY_SUBTITLE: {
		value: 'Claim all rewards',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	QUEST_DAILY_SUBTITLE_MOBILE: {
		value: 'Claim all rewards',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	QUEST_TIMER_ICON: {
		value: '',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	QUEST_TIMER_ICON_MOBILE: {
		value: '',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	QUEST_DAILY_BTN: {
		value: 'GO',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	QUEST_DAILY_BTN_CLAIMED: {
		value: 'CLAIMED',
		config: {
			fill: '#F4C123',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	QUEST_DAILY_BTN_CLAIM: {
		value: 'CLAIM',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	QUEST_ITEM_HEADER: {
		value: '',
		config: {
			fill: '#396AA4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	QUEST_ITEM_SUBTITLE: {
		value: '',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	QUEST_ITEM_DESC: {
		value: '',
		config: {
			fill: '#F09833',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	QUEST_ACTIVATE_BTN: {
		value: 'ACTIVATE',
		config: {
			fill: '#FFFFFF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	QUEST_ACTIVATED_BTN: {
		value: 'ACTIVATED',
		config: {
			fill: '#F4C123',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	QUEST_ITEM_HEADER_1: {
		value: 'Catch 3x Alien Symbol'
	},
	QUEST_ITEM_SUBTITLE_1: {
		value: 'Bet relevant'
	},
	QUEST_ITEM_DESC_1: {
		value: '50 freespin'
	},
	QUEST_ITEM_HEADER_2: {
		value: 'Trigger Min. 2x Scatter'
	},
	QUEST_ITEM_SUBTITLE_2: {
		value: 'Bet relevant free'
	},
	QUEST_ITEM_DESC_2: {
		value: 'Bonus Round'
	},
	QUEST_ITEM_HEADER_3: {
		value: 'Trigger Min. 2x Scatter'
	},
	QUEST_ITEM_SUBTITLE_3: {
		value: 'Bet relevant'
	},
	QUEST_ITEM_DESC_3: {
		value: 'Bonus Discount'
	},
	QUEST_ITEM_HEADER_4: {
		value: 'Trigger Min. 2x Scatter'
	},
	QUEST_ITEM_SUBTITLE_4: {
		value: 'Bet relevant'
	},
	QUEST_ITEM_DESC_4: {
		value: '20% Bonus Discount'
	},
	QUEST_ITEM_CLAIM_IMG_TEXT: {
		value: '',
		config: {
			fill: ['#F1F1F1', '#B4C8FB'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 42
		}
	},
	QUEST_ITEM_CLAIM_HEADER: {
		value: '',
		config: {
			fill: 'F09833',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	QUEST_ITEM_CLAIM_SUBTITLE: {
		value: '',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18,
			wordWrap: true,
			wordWrapWidth: 200
		}
	},
	QUEST_CLAIM_ITEM_HEADER_1: {
		value: '50 Freespin'
	},
	QUEST_CLAIM_ITEM_HEADER_2: {
		value: 'Bonus Round'
	},
	QUEST_CLAIM_ITEM_HEADER_3: {
		value: 'Bonus Discount'
	},
	QUEST_CLAIM_ITEM_HEADER_4: {
		value: 'Wild Respin'
	},
	QUEST_CLAIM_ITEM_DESC_1: {
		value: 'Get extra chances to play and keep win'
	},
	QUEST_CLAIM_ITEM_DESC_2: {
		value: 'Get into free bonus round and try fortune'
	},
	QUEST_CLAIM_ITEM_DESC_3: {
		value: 'Get 20% of required bonus buy amount'
	},
	QUEST_CLAIM_ITEM_DESC_4: {
		value: 'Get 3x random sticky wild respin on reel'
	}
};
